import Swal from 'sweetalert2'

// Configuración global de SweetAlert2
const SweetAlert = {
  install(app) {
    // Configuración por defecto
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    // Métodos globales
    app.config.globalProperties.$swal = Swal
    app.config.globalProperties.$toast = Toast
        
    // Métodos de conveniencia
    app.config.globalProperties.$alert = (title, text, icon = 'info') => {
      return Swal.fire({
        title,
        text,
        icon,
        confirmButtonText: 'OK'
      })
    }

    app.config.globalProperties.$confirm = (title, text, confirmText = 'Sí', cancelText = 'No') => {
      return Swal.fire({
        title,
        text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      })
    }

    // Nuevo método para mostrar modal de link de pago
    app.config.globalProperties.$paymentLink = (url, options = {}) => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Opciones de configuración para habilitar/deshabilitar botones
      const config = {
        showShare: options.showShare !== false, // Por defecto true
        showCopy: options.showCopy !== false,   // Por defecto true
        showOpen: options.showOpen !== false,   // Por defecto true
        enableShare: options.enableShare !== false, // Por defecto habilitado
        enableCopy: options.enableCopy !== false,   // Por defecto habilitado
        enableOpen: options.enableOpen !== false,   // Por defecto habilitado
        shareOptions: {
          email: options.shareOptions?.email !== false,    // Por defecto true
          whatsapp: options.shareOptions?.whatsapp !== false && isMobile, // Solo en móvil
          sms: options.shareOptions?.sms !== false && isMobile, // Solo en móvil
          contacts: options.shareOptions?.contacts !== false && isMobile // Solo en móvil
        },
        ...options
      };

      return Swal.fire({
        title: 'Tu link de pago está listo:',
        icon: 'success',
        html: `
          <div style="margin: 20px 0;">
            <div style="
              background-color: #f8f9fa;
              border: 2px solid #e9ecef;
              border-radius: 8px;
              padding: 15px;
              margin: 15px 0;
              word-break: break-all;
              font-family: monospace;
              font-size: 14px;
              color: #495057;
            ">${url}</div>
            <p style="color: #6c757d; font-size: 14px; margin: 10px 0;">
              Recuerda que este <strong>link</strong> tiene una vigencia de dos días
            </p>
          </div>
        `,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true,
        width: 600,
        customClass: {
          popup: 'payment-link-modal'
        },
        footer: `
          <div style="display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
            ${config.showShare ? `
              <button id="share-btn" class="swal2-styled ${!config.enableShare ? 'swal2-disabled' : ''}" 
                style="background-color: ${config.enableShare ? '#10b981' : '#6c757d'}; 
                color: var(--swal2-confirm-button-color);
                font-size: 1em; margin: .3125em;
                padding: .625em 1.1em; border-radius: var(--swal2-confirm-button-border-radius); 
                ${!config.enableShare ? 'cursor: not-allowed; opacity: 0.6;' : ''}"
                ${!config.enableShare ? 'disabled' : ''}>
                Compartir
              </button>
            ` : ''}
            ${config.showCopy ? `
              <button id="copy-btn" class="swal2-styled ${!config.enableCopy ? 'swal2-disabled' : ''}" 
                style="background-color: ${config.enableCopy ? '#17a2b8' : '#6c757d'}; 
                color: var(--swal2-confirm-button-color);
                font-size: 1em; margin: .3125em;
                padding: .625em 1.1em; border-radius: var(--swal2-confirm-button-border-radius); 
                ${!config.enableCopy ? 'cursor: not-allowed; opacity: 0.6;' : ''}"
                ${!config.enableCopy ? 'disabled' : ''}>
                Copiar
              </button>
            ` : ''}
            ${config.showOpen ? `
              <button id="open-btn" class="swal2-styled ${!config.enableOpen ? 'swal2-disabled' : ''}" 
                style="background-color: ${config.enableOpen ? '#007bff' : '#6c757d'}; 
                color: var(--swal2-confirm-button-color);
                font-size: 1em; margin: .3125em;
                padding: .625em 1.1em; border-radius: var(--swal2-confirm-button-border-radius);
                ${!config.enableOpen ? 'cursor: not-allowed; opacity: 0.6;' : ''}"
                ${!config.enableOpen ? 'disabled' : ''}>
                Abrir
              </button>
            ` : ''}
          </div>
        `,
        didOpen: (popup) => {
          // Funcionalidad del botón Compartir
          const shareBtn = popup.querySelector('#share-btn');
          if (shareBtn && config.enableShare) {
            shareBtn.addEventListener('click', () => {
              handleShare(url, config.shareOptions);
            });
          }

          // Funcionalidad del botón Copiar
          const copyBtn = popup.querySelector('#copy-btn');
          if (copyBtn && config.enableCopy) {
            copyBtn.addEventListener('click', async () => {
              try {
                await navigator.clipboard.writeText(url);
                // Cerrar el modal actual primero
                Swal.close();
                // Mostrar mensaje de éxito con SweetAlert
                await Swal.fire({
                  title: 'Link copiado',
                  text: 'El link ha sido copiado al portapapeles exitosamente',
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false,
                  timerProgressBar: true
                });
              } catch (err) {
                // Fallback para navegadores que no soportan clipboard API
                const textArea = document.createElement('textarea');
                textArea.value = url;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                  document.execCommand('copy');
                  // Cerrar el modal actual primero
                  Swal.close();
                  // Mostrar mensaje de éxito
                  await Swal.fire({
                    title: 'Link copiado',
                    text: 'El link ha sido copiado al portapapeles exitosamente',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                    timerProgressBar: true
                  });
                } catch (err) {
                  // Cerrar el modal actual primero
                  Swal.close();
                  // Mostrar mensaje de error
                  await Swal.fire({
                    title: 'Error',
                    text: 'No se pudo copiar el link al portapapeles',
                    icon: 'error',
                    confirmButtonText: 'OK'
                  });
                }
                document.body.removeChild(textArea);
              }
            });
          }

          // Funcionalidad del botón Abrir
          const openBtn = popup.querySelector('#open-btn');
          if (openBtn && config.enableOpen) {
            openBtn.addEventListener('click', () => {
              window.open(url, '_blank');
              Swal.close();
            });
          }
        }
      });
    }

    // Función auxiliar para manejar el compartir
    function handleShare(url, shareOptions) {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      if (isMobile) {
        // En móvil, mostrar opciones de compartir
        const shareButtons = [];
   
        if (shareOptions.whatsapp) {
          shareButtons.push(`
            <button class="share-option swal2-styled" data-type="whatsapp" style="
              width: 100%;
              font-size: 1em; 
              color: #fff;
              margin: .3125em;
              padding: .625em 1.1em; 
              border-radius: var(--swal2-confirm-button-border-radius);
              background-color: #10b981;
            ">Compartir por WhatsApp</button>
          `);
        }
        
        if (shareOptions.email) {
            shareButtons.push(`
              <button class="share-option swal2-styled" data-type="email" style="
                width: 100%;
                font-size: 1em; 
                color: #fff;
                margin: .3125em;
                padding: .625em 1.1em; 
                border-radius: var(--swal2-confirm-button-border-radius);
                background-color: #17a2b8;
              ">Compartir por Email</button>
            `);
        }

        if (shareOptions.sms) {
          shareButtons.push(`
            <button class="share-option swal2-styled" data-type="sms" style="
              width: 100%;
              font-size: 1em; 
              color: #fff;
              margin: .3125em;
              padding: .625em 1.1em; 
              border-radius: var(--swal2-confirm-button-border-radius);
              background-color: #007bff;
            ">Compartir por SMS</button>
          `);
        }

        if (shareOptions.contacts && navigator.share) {
          shareButtons.push(`
            <button class="share-option swal2-styled" data-type="native" style="
              width: 100%;
              font-size: 1em; 
              color: #fff;
              margin: .3125em;
              padding: .625em 1.1em; 
              border-radius: var(--swal2-confirm-button-border-radius);
              background-color: #127281;
            ">Compartir</button>
          `);
        }

        Swal.fire({
          title: 'Compartir link de pago',
          icon: 'info',
          html: `<div>${shareButtons.join('')}</div>`,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          didOpen: (popup) => {
            const shareOptionBtns = popup.querySelectorAll('.share-option');
            shareOptionBtns.forEach(btn => {
              btn.addEventListener('click', () => {
                const type = btn.getAttribute('data-type');
                executeShare(type, url);
                Swal.close();
              });
            });
          }
        });
      } else {
        // En escritorio, solo email
        if (shareOptions.email) {
          const subject = encodeURIComponent('Link de pago');
          const body = encodeURIComponent(`Mi link de pago es: ${url}`);
          window.location.href = `mailto:?subject=${subject}&body=${body}`;
        }
      }
    }

    // Función para ejecutar el compartir según el tipo
    function executeShare(type, url) {
      const message = `Mi link de pago es: ${url}`;
      
      switch(type) {
        case 'email': {
          const subject = encodeURIComponent('Link de pago');
          const body = encodeURIComponent(message);
          window.location.href = `mailto:?subject=${subject}&body=${body}`;
          break;
        }
          
        case 'whatsapp': {
          const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, '_blank');
          break;
        }
          
        case 'sms': {
          window.location.href = `sms:?body=${encodeURIComponent(message)}`;
          break;
        }
          
        case 'native': {
          if (navigator.share) {
            navigator.share({
              title: 'Link de pago',
              text: message,
              url: url
            }).catch(err => {
              console.log('Error al compartir:', err);
            });
          }
          break;
        }
      }
    }
  }
}

export default SweetAlert